module.exports = __webpack_public_path__ + "static/media/Shabnam-Thin.bcfcd96c.ttf";